import { ResponseAttr } from "./common/types";
import { publicRequest } from "@utils/public-request";
import { UseQueryOptions, UseQueryResult, useQuery } from "react-query";

const HELPS_ENDPOINT = "api/v1/helps";

type AuthAttr = {
  access_token: string;
  user_id: string;
};

type ContactSupportAttr = {
  help_id: string;
  data: {
    name: string;
    email: string;
    message: string;
    phone_number: string;
  };
};

const useContactSupport = (
  help_id?: string,
  config?: UseQueryOptions<Array<ContactSupportAttr>>
): UseQueryResult<Array<ContactSupportAttr>> => {
  return useQuery<Array<ContactSupportAttr>>(
    "contact-support",
    async () =>
      (
        await publicRequest.get<ResponseAttr<Array<ContactSupportAttr>>>(
          HELPS_ENDPOINT,
          {
            params: { help_id },
          }
        )
      ).data.data,
    config
  );
};

export type { AuthAttr };
export { useContactSupport };
